import type { ReactNode } from 'react';

export const symbol_sports: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M440-200q-101 0-170.5-69.5T200-440q0-11 1-23t3-21q-5 2-12 3t-12 1q-44 0-72-28t-28-72q0-44 28-72t72-28q31 0 57 18.5t37 46.5q31-28 74.5-46.5T441-680h409q13 0 21.5 8.5T880-650v60q0 13-8.5 21.5T850-560H680v120q0 101-69.5 170.5T440-200ZM209-551q11-11 11-29t-11-29q-11-11-29-11t-29 11q-11 11-11 29t11 29q11 11 29 11t29-11Zm331 211q40-40 40-100t-40-100q-40-40-100-40t-100 40q-40 40-40 100t40 100q40 40 100 40t100-40Zm-43.5-43.5Q520-407 520-440t-23.5-56.5Q473-520 440-520t-56.5 23.5Q360-473 360-440t23.5 56.5Q407-360 440-360t56.5-23.5ZM440-440Z"
		/>
	</svg>
);
